// api
import { fetchApi } from '@/api'
// actions
const academicAttendantAll = (context) => {
  let url = 'academic/attendant'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('ACADEMIC_ATTENDANT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicAttendantCreate = (context,data) => {
  let Json = JSON.stringify(data)
  let url = 'academic/attendant'
  return fetchApi(url, Json, 'POST')
    .then((response) => {
      context.commit('ACADEMIC_ATTENDANT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicAttendantEdit = (context,data) => {
  let obj = JSON.parse(data)
  let url = 'academic/attendant/' + obj.id + '/edit'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_ATTENDANT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicAttendantUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'academic/attendant/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ACADEMIC_ATTENDANT_ALL', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  academicAttendantAll,
  academicAttendantCreate,
  academicAttendantUpdate,
  academicAttendantEdit
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/attendant/actions.js